import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { Assessment } from "@thalamos/haven-common";

import { AssessmentKindChip } from "../../components/AssessmentKindChip/AssessmentKindChip.js";
import { AssessmentStatusChip } from "../../components/AssessmentStatusChip/AssessmentStatusChip.js";
import { VISUALLY_HIDDEN } from "../../theme/visuallyHidden.js";
import { assessmentReference } from "./assessmentReference.js";

/** The assessment record's heading, with which assessment it is and where it stands beside it: its reference, state and kind. */
export const AssessmentRecordTitle = ({
  assessment,
  headingId,
}: {
  assessment: Assessment;
  /** For a region the heading names. */
  headingId?: string | undefined;
}) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction="row"
      spacing={1.5}
      alignItems="center"
      useFlexGap
      flexWrap="wrap"
      sx={{ minWidth: 0 }}
    >
      <Typography
        id={headingId}
        component="h2"
        sx={{ fontSize: 18, fontWeight: 600, color: "primary.main" }}
      >
        {t("assessment.layout.record")}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          letterSpacing: "0.02em",
          color: "text.secondary",
        }}
      >
        <Box component="span" sx={VISUALLY_HIDDEN}>
          {`${t("assessment.layout.reference")} `}
        </Box>
        {assessmentReference(assessment)}
      </Typography>
      <AssessmentStatusChip status={assessment.status} />
      <AssessmentKindChip definitive={assessment.definitive} />
    </Stack>
  );
};
